import { Paper, Title, Switch, NumberInput, Stack, Button, Group, Text } from '@mantine/core';
import { useForm } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import { useAutomationConfig, useUpdateAutomationConfig } from '@/hooks/useAutomation';
import { useEffect } from 'react';

export function BirthdayConfig() {
  const { data: config, isLoading } = useAutomationConfig();
  const updateConfig = useUpdateAutomationConfig();

  const form = useForm({
    initialValues: {
      enabled: false,
      tokenCount: 5,
    },
  });

  useEffect(() => {
    if (config) {
      form.setValues({
        enabled: config.birthday.enabled,
        tokenCount: config.birthday.tokenCount,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config]);

  const handleSave = () => {
    if (!config) return;
    updateConfig.mutate(
      {
        ...config,
        birthday: { enabled: form.values.enabled, tokenCount: form.values.tokenCount },
      },
      {
        onSuccess: () => notifications.show({ message: 'Geburtstags-Konfiguration gespeichert.', color: 'green' }),
      },
    );
  };

  if (isLoading) return null;

  return (
    <Paper withBorder p="md" radius="md">
      <Stack gap="sm">
        <Title order={4}>Geburtstags-Token</Title>
        <Text size="sm" c="dimmed">
          Token werden automatisch am Geburtstag eines Inhabers versendet.
        </Text>

        <Switch
          label="Automatische Geburtstags-Token aktiviert"
          checked={form.values.enabled}
          onChange={(e) => form.setFieldValue('enabled', e.currentTarget.checked)}
        />

        <NumberInput
          label="Anzahl Token pro Geburtstag"
          min={1}
          max={1000}
          disabled={!form.values.enabled}
          {...form.getInputProps('tokenCount')}
          w={300}
        />

        <Group justify="flex-end">
          <Button onClick={handleSave} loading={updateConfig.isPending}>
            Speichern
          </Button>
        </Group>
      </Stack>
    </Paper>
  );
}
